module.exports = __webpack_public_path__ + "static/img/u96.9fe8bfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u96.png
// module id = 1G0p
// module chunks = 73